module.exports = __webpack_public_path__ + "img/xunmeizaixian.png";